// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"340":"c59f3dbee564ef3c143b","411":"e87a905019c9c1c2bde8"}[chunkId] + ".bundle.js";
};